import axiosInstance from "../../utils/axiosInstance";

const AuditClient = {
  // simple paged fetch: /api/admin/audit?page=0&size=20
  getAll: (params = {}) => axiosInstance.get("/audit", { params }),
  // get by entity type
  getByEntity: (entityType, params = {}) => axiosInstance.get(`/audit/entity/${entityType}`, { params }),
  getBookCreationSummary: () => axiosInstance.get("/audit/summary/book-creations"),
};

export default AuditClient;
